<template>
  <div class="vipabout">
    <Nav></Nav>
    <div class="vip-about">
      <div class="become-vip" @click="goClick">
        <div class="become-icon"></div>
      </div>
      <div class="about">
        <div class="back" @click="goBack">
          <div class="back-icon"></div>
          返回
        </div>
        <div class="title-icon" v-if="false">
          <div class="title-icon2"></div>
          <!-- <div class="title-text">新用户免费体验7天</div> -->
        </div>
        <div class="white-wrap">
          <div class="white-title" v-if="false">
            <div class="white-text">高级功能示意图</div>
          </div>
          <div class="about1" v-if="false">
            <div class="about-bg"></div>
            <div class="about-bg2"></div>
            <div class="about-item">客户端</div>
            <div class="about-item2"></div>
            <div class="about-item about-item3">设备端</div>
            <div class="about-item4">
              <div class="item4-text">
                基础服务
                <div class="item4-icon"></div>
              </div>
              <div class="item4-btn">受控设备</div>
              <div class="item4-btn item4-btn2">设备服务</div>
            </div>
            <div class="about-item4 about-item5">
              <div class="item4-text">
                基础服务
                <div class="item4-icon"></div>
              </div>
              <div class="item4-btn">受控设备</div>
              <div class="item4-btn item4-btn2">设备服务</div>
              <div class="item4-btn item4-btn2">自定义映射</div>
            </div>
            <div class="about-item6">外网</div>
            <div class="about-item7">内网</div>
          </div>
          <div class="line" v-if="false"></div>
          <div class="white-title2">
            <div class="title2-text">高级功能</div>
            <div class="title2-icon"></div>
            <div class="title2-text">基础功能</div>
          </div>
          <div class="about2">
            <div class="about2-item">
              <div class="item-icon"></div>
              <div class="item-text">高级功能</div>
              <div class="item-line"></div>
              <div class="item-btn">访问多设备及多服务</div>
              <div class="item-text2">通过设备端访问同局域网其他设备及服务</div>
              <div class="item-line item-line2"></div>
              <div class="item-btn">中转任意内网服务</div>
              <div class="item-text2">
                绑定的任意设备端均支持中转其他内网服务
              </div>
              <div class="item-line item-line2"></div>
            </div>
            <div class="about2-item2">
              <div class="item2-text">Normal</div>
              <div class="item2-text2">基础功能</div>
              <div class="item2-line"></div>
              <div class="item2-btn">仅可访问</div>
              <div class="item2-text3">访问设备端设备及其服务</div>
              <div class="item2-line item2-line2"></div>
            </div>
          </div>
          <div class="line"></div>
          <div class="white-title3">
            <div class="white-text">如何使用高级功能</div>
          </div>
          <div class="about3">
            <div class="about3-item">
              <div class="item-text">01</div>
              <div class="item-text2">发现服务</div>
              <div class="item-text3">
                <div class="item-text3a">
                  点击“发现服务”小宝设备端将发现局域网内的常用服务，如：
                </div>
                <div class="item-text3a">
                  远程NAS，windows远程桌面、路由器管理等服务；
                </div>
                <div class="item-text3a">
                  添加高级服务后可在服务列表直接发起访问。
                </div>
              </div>
            </div>
            <div class="about3-item2">
              <div class="item2-btn">发现服务</div>
              <div class="item2-icon"></div>
              <div class="item2-icon2">
                <div class="item2-icon3"></div>
              </div>
            </div>
            <div class="about3-item about3-item3">
              <div class="item-text">02</div>
              <div class="item-text2">手动添加服务</div>
              <div class="item-text3 item-text4">
                <div class="item-text3a">
                  点击“手动添加”选择需访问服务的网络（即受控设备）；
                </div>
                <div class="item-text3a">输入服务的IP及端口并添加；</div>
                <div class="item-text3a">
                  添加完成后可在服务列表直接发起访问。
                </div>
              </div>
            </div>
            <div class="about3-item2 about3-item4">
              <div class="item2-btn">自定义添加</div>
              <div class="item2-icon"></div>
              <div class="item2-icon2">
                <div class="item2-icon3"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import async from "async";
import Nav from "@/components/Common/Nav.vue";
import HomeNav from "@/components/Common/HomeNav.vue";
export default {
  components: {
    Nav,
    HomeNav,
  },
  methods: {
    goClick: function () {
      this.$router.push("/home/vip");
    },
    goBack: function () {
      this.$router.back(-1);
    },
  },
};
</script>
<style lang="less" scoped>
.vip-about {
  position: relative;
  margin: 0 auto;
  width: 950px;
  height: 500px;
  box-sizing: border-box;
  .become-vip {
    position: absolute;
    padding-top: 1px;
    z-index: 5;
    bottom: 0px;
    left: 2px;
    width: 928px;
    height: 102px;
    background-image: url("../assets/vip/about19.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    cursor: pointer;
    .become-icon {
      margin: 0 auto;
      margin-top: 37px;
      width: 269px;
      height: 40px;
      background-image: url("../assets/vip/about20.svg");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
  .about {
    padding-top: 1px;
    margin: 0 auto;
    width: 940px;
    height: 100%;
    background-color: #1f3454;
    border-radius: 4px;
    overflow: auto;
    box-sizing: border-box;

    .back {
      width: 200px;
      line-height: 50px;
      font-size: 14px;
      color: #ffffff;
      cursor: pointer;
      .back-icon {
        display: inline-block;
        margin-top: 16px;
        margin-left: 24px;
        margin-right: 6px;
        vertical-align: top;
        width: 16px;
        height: 16px;
        background-image: url("../assets/vip/back2.svg");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }
    .title-icon {
      position: relative;
      padding-top: 1px;
      margin: 0 auto;
      margin-top: -70px;
      margin-left: 92px;
      width: 705px;
      height: 150px;
      background-image: url("../assets/vip/about3-2.png");
      background-repeat: no-repeat;
      background-size: 100% 150%;
      background-position: center top 20px;
      box-sizing: border-box;
      .title-icon2 {
        margin: 0 auto;
        margin-left: 205px;
        margin-top: 70px;
        width: 322px;
        height: 57px;
        background-image: url("../assets/vip/about2.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .title-text {
        position: absolute;
        top: 167px;
        left: 50%;
        margin-left: 16px;
        transform: translate(-50%, 0);
        color: #163769;
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
      }
    }
    .white-wrap {
      padding-top: 20px;
      padding-bottom: 110px;
      margin: 0 auto;
      margin-bottom: 13px;
      width: 836px;
      background-color: #ffffff;
      border-radius: 4px;
      .white-title {
        padding-top: 1px;
        margin: 0 auto;
        width: 300px;
        font-weight: 600;
        font-size: 24px;
        height: 20px;
        box-sizing: border-box;
        text-align: center;
        color: #1a1a1a;
        background-image: url("../assets/vip/about4.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center;
        .white-text {
          margin-top: -7px;
          line-height: 34px;
        }
      }
      .about1 {
        position: relative;
        margin: 0 auto;
        margin-top: 36px;
        width: 622px;
        height: 308px;
        .about-bg {
          position: absolute;
          right: 0;
          top: 0;
          height: 100%;
          width: 595px;
          background: #fbfcff;
          opacity: 0.9;
          border-radius: 860px;
        }
        .about-bg2 {
          position: absolute;
          right: 24px;
          top: 24px;
          width: 444px;
          height: 260px;
          background: #e2f1ff;
          opacity: 0.7;
          border-radius: 240px;
        }
        .about-item {
          position: absolute;
          left: 0;
          top: 72px;
          width: 64px;
          height: 148px;
          line-height: 148px;
          color: #1a1a1a;
          font-size: 14px;
          border-radius: 120px;
          background-image: url("../assets/vip/about5.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          text-align: center;
          box-shadow: 0px 2px 4px rgba(152, 172, 231, 0.2);
        }
        .about-item2 {
          position: absolute;
          top: 130px;
          left: 80px;
          width: 32px;
          height: 22px;
          background-image: url("../assets/vip/about6.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
        .about-item3 {
          left: 128px;
        }
        .about-item4 {
          padding-top: 1px;
          position: absolute;
          width: 139px;
          height: 184px;
          left: 224px;
          top: 72px;
          border: 1px solid #889cff;
          border-radius: 16px;
          box-sizing: border-box;
          background-color: #ffffff;
          .item4-text {
            margin-top: 15px;
            margin-left: 10px;
            font-weight: 600;
            font-size: 18px;
            line-height: 25px;
            color: #1a1a1a;
            .item4-icon {
              display: inline-block;
              margin-left: 4px;
              margin-top: -4px;
              vertical-align: top;
              height: 16px;
              width: 14px;
              background-image: url("../assets/vip/about7.png");
              background-repeat: no-repeat;
              background-size: 100% 100%;
            }
          }
          .item4-btn {
            margin: 0 auto;
            margin-top: 11px;
            width: 119px;
            height: 36px;
            line-height: 36px;
            text-align: center;
            font-size: 14px;
            color: #4151a1;
            border-radius: 24px;
            background-image: url("../assets/vip/about8.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
          }
          .item4-btn {
            margin-top: 8px;
          }
        }
        .about-item5 {
          left: 387px;
        }
        .about-item6 {
          position: absolute;
          top: 36px;
          left: 146px;
          color: #1a1a1a;
          font-size: 14px;
        }
        .about-item7 {
          position: absolute;
          right: 233px;
          top: 36px;
          color: #1a1a1a;
          font-size: 14px;
        }
      }
      .line {
        margin: 0 auto;
        margin-top: 36px;
        width: 740px;
        height: 2px;
        background-color: #f3f5f7;
      }
      .white-title2 {
        margin: 0 auto;
        margin-top: 48px;
        padding-top: 1px;
        width: 383px;
        font-weight: 600;
        font-size: 24px;
        height: 20px;
        box-sizing: border-box;
        text-align: center;
        color: #1a1a1a;
        background-image: url("../assets/vip/about9.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center;
        .title2-text,
        .title2-icon {
          display: inline-block;
          vertical-align: top;
          margin-top: -7px;
          line-height: 34px;
        }
        .title2-icon {
          margin-top: -12px;
          margin-left: 8px;
          margin-right: 7px;
          width: 43px;
          height: 45px;
          background-image: url("../assets/vip/about10.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center;
        }
      }
      .about2 {
        position: relative;
        margin-top: 46px;
        height: 256px;
        width: 100%;
        text-align: center;
        .about2-item,
        .about2-item2 {
          display: inline-block;
          vertical-align: top;
        }
        .about2-item {
          position: absolute;
          padding-top: 1px;
          left: 167px;
          top: 0;
          z-index: 1;
          width: 311px;
          height: 256px;
          background: linear-gradient(174.55deg, #f5e0ca 2.95%, #f3ebe2 95.65%);
          box-shadow: 8px 4px 12px rgba(119, 129, 145, 0.12);
          border-radius: 16px;
          box-sizing: border-box;
          .item-icon {
            position: absolute;
            left: 24px;
            top: 0;
            width: 89px;
            height: 61px;
            background-image: url("../assets/vip/about11.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
          }
          .item-text {
            position: absolute;
            left: 80px;
            top: 24px;
            text-align: left;
            font-weight: 600;
            font-size: 18px;
            line-height: 25px;
            color: #243c64;
          }
          .item-line {
            margin: 0 auto;
            margin-top: 60px;
            width: 263px;
            height: 1px;
            background-color: rgba(231, 202, 175, 0.5);
          }
          .item-line2 {
            margin-top: 14px;
          }
          .item-btn {
            position: relative;
            margin-left: 33px;
            margin-top: 12px;
            width: 164px;
            height: 28px;
            background: linear-gradient(91deg, #243c64 6%, #243c64 95%);
            border-radius: 24px;
            font-weight: 600;
            font-size: 14px;
            line-height: 28px;
            color: #ffffff;
          }
          .item-btn::before {
            position: absolute;
            top: 12px;
            left: 8px;
            content: "";
            width: 4px;
            height: 4px;
            background: #ffffff;
            border-radius: 50%;
          }
          .item-text2 {
            margin-left: 33px;
            margin-top: 12px;
            color: #5c5c5c;
            font-size: 14px;
            line-height: 20px;
            text-align: left;
          }
        }
        .about2-item2 {
          position: absolute;
          right: 167px;
          top: 68px;
          width: 191px;
          height: 160px;
          border-radius: 0px 8px 8px 0px;
          overflow: hidden;
          background: #f8f8fc;
          border-top: 1px solid rgba(69, 73, 80, 0.08);
          border-right: 1px solid rgba(69, 73, 80, 0.08);
          border-bottom: 1px solid rgba(69, 73, 80, 0.08);
          .item2-text {
            margin-top: -5px;
            margin-right: -20px;
            font-weight: 600;
            font-size: 38px;
            line-height: 53px;
            text-align: right;
            color: rgba(0, 0, 0, 0.06);
          }
          .item2-text2 {
            position: absolute;
            top: 22px;
            left: 25px;
            font-weight: 600;
            font-size: 18px;
            line-height: 25px;
            text-align: center;
            color: #000000;
          }
          .item2-line {
            position: absolute;
            left: 16px;
            top: 58px;
            width: 159px;
            height: 1px;
            background-color: #ececf8;
          }
          .item2-line2 {
            top: 144px;
          }
          .item2-btn {
            position: absolute;
            left: 20px;
            top: 70px;
            font-size: 14px;
            width: 80px;
            height: 28px;
            line-height: 28px;
            background: #d1d1d1;
            border-radius: 24px;
            color: #666666;
          }
          .item2-text3 {
            position: absolute;
            bottom: 30px;
            left: 0;
            width: 191px;
            text-align: center;
            font-size: 14px;
            line-height: 20px;
            color: #999999;
          }
        }
      }
      .white-title3 {
        padding-top: 1px;
        margin: 0 auto;
        margin-top: 55px;
        width: 324px;
        font-weight: 600;
        font-size: 24px;
        height: 20px;
        box-sizing: border-box;
        text-align: center;
        color: #1a1a1a;
        background-image: url("../assets/vip/about12.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center;
        .white-text {
          margin-top: -7px;
          line-height: 34px;
        }
      }
      .about3 {
        .about3-item {
          margin-top: 43px;
          margin-left: 112px;
          .item-text,
          .item-text2,
          .item-text3,
          .item-text3a {
            display: inline-block;
            vertical-align: top;
          }
          .item-text {
            font-weight: 700;
            font-size: 32px;
            line-height: 39px;
            color: #213656;
          }
          .item-text2 {
            margin-left: 16px;
            font-weight: 600;
            font-size: 20px;
            line-height: 39px;
            color: #243a5e;
          }
          .item-text3 {
            margin-top: -5px;
            margin-left: 76px;
            width: 418px;
            color: #5c5c5c;
            font-size: 14px;
            line-height: 20px;
          }
          .item-text4 {
            margin-left: 36px;
          }
        }
        .about3-item2 {
          margin-top: 16px;
          padding-top: 1px;
          .item2-btn,
          .item2-icon,
          .item2-icon2 {
            display: inline-block;
            vertical-align: top;
          }
          .item2-btn {
            position: relative;
            margin-left: 97px;
            margin-top: 75px;
            width: 186px;
            height: 48px;
            background: linear-gradient(156deg, #2f4386 27%, #1b3065 82%);
            box-shadow: 0px 3px 7px rgba(43, 48, 57, 0.2);
            border-radius: 200px;
            font-weight: 700;
            font-size: 18px;
            line-height: 48px;
            text-align: center;
            color: #ffffff;
          }
          .item2-btn::before {
            position: absolute;
            top: 31px;
            right: -3px;
            content: "";
            width: 51px;
            height: 63px;
            background-image: url("../assets/vip/about16.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
          }
          .item2-icon {
            margin-top: 82px;
            margin-left: 36px;
            width: 36px;
            height: 36px;
            background-image: url("../assets/vip/about13.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
          }
          .item2-icon2 {
            position: relative;
            margin-left: 60px;
            width: 324px;
            height: 202px;
            background-image: url("../assets/vip/about14.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            box-shadow: 0px 2px 12px rgba(56, 61, 79, 0.4);
            border-radius: 4px;
            .item2-icon3 {
              position: absolute;
              top: 110px;
              left: -29px;
              width: 161px;
              height: 60px;
              background-image: url("../assets/vip/about15.png");
              background-repeat: no-repeat;
              background-size: 100% 100%;
            }
          }
        }
        .about3-item3 {
          margin-top: 77px;
        }
        .about3-item4 {
          margin-top: 24px;
          .item2-icon2 {
            height: 203px;
            background-image: url("../assets/vip/about17.png");
            .item2-icon3 {
              top: 99px;
              width: 173px;
              height: 119px;
              background-image: url("../assets/vip/about18.png");
              box-shadow: 0px 6px 16px rgba(63, 75, 118, 0.3);
              border-radius: 4px;
            }
          }
        }
      }
    }
  }
}
</style>